// extracted by mini-css-extract-plugin
export default {"pageContainer":"App_pageContainer__YUrH3"};